<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex"
    [isPrimaryBtnEnabled]="okEnabled()" [secondaryButtonLabel]="'Cancel'" [primaryButtonLabel]="'OK'"
    [resizeHorizontal]="true" [resizeVertical]="true" [resizeHorizontalMin]="700" [resizeVerticalMin]="500">
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label for="name" requiredAsterisk>Field Name:</label>
        </div>
        <div class="modal-row-column-auto group-field">
            <input type="text" id="name" [(ngModel)]="name"
                [attr.data-automation-id]="modalAutomationId + '-name-input'" name="name" maxlength="32">
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label>Mode:</label>
        </div>
        <div class="modal-row-column-auto group-field">
            <button [attr.data-automation-id]="modalAutomationId + '-mode-chain-button'" type="button"
                [ngClass]="mode === GroupFieldMode.FIRST_NON_EMPTY ? 'btn-group-active' : 'btn-group-default'"
                (click)="modeChanged(GroupFieldMode.FIRST_NON_EMPTY)">
                <div>Chain</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
            <button [attr.data-automation-id]="modalAutomationId + '-mode-delimited-values-button'" type="button"
                [ngClass]="mode === GroupFieldMode.CONCATENATE ? 'btn-group-active' : 'btn-group-default'"
                (click)="modeChanged(GroupFieldMode.CONCATENATE)">
                <div>Delimited Values</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
            <button [attr.data-automation-id]="modalAutomationId + '-mode-duplicate-values-button'" type="button"
                [ngClass]="mode === GroupFieldMode.DUPLICATE_VALUES ? 'btn-group-active' : 'btn-group-default'"
                (click)="modeChanged(GroupFieldMode.DUPLICATE_VALUES)">
                <div>Duplicate Values</div>
                <i class="fa fa-caret-up up-caret-active"></i>
            </button>
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label for="modeValue">{{ mode === GroupFieldMode.FIRST_NON_EMPTY ? 'Default Value:' : 'Delimiter:'
                }}</label>
        </div>
        <div class="modal-row-column-auto group-field">
            <input type="text" id="modeValue" [(ngModel)]="modeValue"
                [attr.data-automation-id]="modalAutomationId + '-mode-input'" name="modeValue"
                [ngStyle]="{'width' : mode === GroupFieldMode.FIRST_NON_EMPTY ? '100%' : '40px'}">
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
        </div>
        <div class="modal-row-column-auto group-field">
            <res-custom-checkbox [automationId]="modalAutomationId + '-propagate-to-family'"
                [(ngModel)]="propagateToFamily" content="Propagate to Family">
            </res-custom-checkbox>
        </div>
    </div>
    <div class="left-right-lists-container"></div>
    <res-left-right-selection-box [sortItemsLeft]="true" [itemsLeft]="itemsLeft" [itemsRight]="itemsRight"
        leftListTitle="Available Fields" (customMoveItems)="customMoveItems($event)"
        (customOnDropItems)="afterDropUpdate($event)"
        [rightListTitle]="mode === GroupFieldMode.DUPLICATE_VALUES ? 'Selected Field' : 'Selected Fields'"
        [leftListGridContext]="leftListGridContext" [leftListColumns]="leftListColumns"
        [rightListColumns]="rightListColumns" [CustomFilterCallback]="CustomFilterCallback">
    </res-left-right-selection-box>
</res-base-modal>